import { Button, Dropdown } from 'antd'
import { ArrowLeft, Bot, Download, MoreHorizontal, NotebookPen, Pencil, Trash2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { BackButton, HeaderInfo, PageTitle, PageSubtitle } from '../../../styles/pageHeaderStyles'
import {
  InsightsPageHeader,
  InsightsTitleRow,
  InsightsActionsRow,
} from '../../survey/pages/SurveyInsightsPageStyles'

export interface InterviewInsightsHeaderProps {
  parentLabel: string
  questionCount: number
  mindmapId: string
  nodeId: string
  simulating: boolean
  onSimulate: () => void
  onDelete: () => void
}

/**
 * Header chrome for the interview insights page: back button, title, and the
 * action cluster (Edit / Record / Simulate / ⋯ overflow menu).
 */
export function InterviewInsightsHeader({
  parentLabel,
  questionCount,
  mindmapId,
  nodeId,
  simulating,
  onSimulate,
  onDelete,
}: InterviewInsightsHeaderProps) {
  const navigate = useNavigate()

  return (
    <InsightsPageHeader>
      <InsightsTitleRow>
        <BackButton
          onClick={() => navigate(`/mindmap/${mindmapId}/research`, { replace: true })}
          title="Back"
        >
          <ArrowLeft size={18} />
        </BackButton>
        <HeaderInfo>
          <PageTitle>{parentLabel || 'Untitled interview'}</PageTitle>
          <PageSubtitle>
            {questionCount} question{questionCount !== 1 ? 's' : ''}
          </PageSubtitle>
        </HeaderInfo>
      </InsightsTitleRow>
      <InsightsActionsRow>
        <Button
          icon={<Pencil size={15} />}
          onClick={() => void navigate(`/mindmap/${mindmapId}/interview/${nodeId}/builder`)}
        >
          Edit
        </Button>
        <Button
          type="primary"
          icon={<NotebookPen size={15} />}
          onClick={() => void navigate(`/interview/${nodeId}/conduct`)}
        >
          Record
        </Button>
        <Button
          icon={<Bot size={16} />}
          loading={simulating}
          disabled={simulating}
          onClick={onSimulate}
        >
          Simulate
        </Button>
        <Dropdown
          trigger={['click']}
          placement="bottomRight"
          menu={{
            items: [
              {
                key: 'export',
                icon: <Download size={13} />,
                label: 'Export PDF',
                onClick: () => window.print(),
              },
              { type: 'divider' },
              {
                key: 'delete',
                icon: <Trash2 size={13} />,
                label: 'Delete',
                danger: true,
                onClick: onDelete,
              },
            ],
          }}
        >
          <Button icon={<MoreHorizontal size={16} />} />
        </Dropdown>
      </InsightsActionsRow>
    </InsightsPageHeader>
  )
}
